/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceEmail } from '../../axios/invoiceEmail'
import type { InvoiceEmailError, InvoiceEmailPathParams, InvoiceEmailResponse } from '../../types/InvoiceEmail'

export const invoiceEmailMutationKey = () => [{ url: '/:organisation/invoices/:invoice/send-email' }] as const

export type InvoiceEmailMutationKey = ReturnType<typeof invoiceEmailMutationKey>

export type InvoiceEmailVariables = {
	organisation: InvoiceEmailPathParams['organisation']
	invoice: InvoiceEmailPathParams['invoice']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::email */
export function useInvoiceEmail<TContext = unknown>(
	options?: UseMutationOptions<InvoiceEmailResponse, AxiosError<InvoiceEmailError>, InvoiceEmailVariables, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: invoiceEmailMutationKey(),
		mutationFn: ({ organisation, invoice }: InvoiceEmailVariables) =>
			invoiceEmail(organisation, invoice, config).then(res => res.data),
		...options,
	})
}
